export default __webpack_public_path__ + "static/media/people.b26a3d4d.svg";